import { gray4, gray6, mainColor, white } from "assets/styleUtils";
import { Header } from "components";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { selectListState } from "recoil/company";
import { getParameterObject } from "utils/common";
import SelectionItem from "./SelectionItem";
import { ISelect } from "./SelectSpotPage";
import styles from "./style.module.css";

export default function SelectClothesPage() {
  const navigation = useNavigate();
  const { search } = useLocation();
  const { category, contructor_no } = getParameterObject({ url: search });
  const decodeCategory = decodeURIComponent(category);

  const clothesArray = [
    {
      no: 1,
      name: decodeCategory === "예복" ? "신랑 예복" : "신랑,신부 한복",
      type: "weddingSuit",
    },
    {
      no: 2,
      name: decodeCategory === "예복" ? "혼주복" : "혼주 한복",
      type: "parentsWear",
    },
  ];
  const recoilSelectValue = useRecoilValue(selectListState);
  const setRecoilSelect = useSetRecoilState(selectListState);
  const [selectClothes, setSelectClothes] = useState<ISelect[]>(
    recoilSelectValue.clothesCheckData || [],
  );

  return (
    <>
      {
        <div style={{ padding: "20px", margin: "10px 0" }}>
          <div>
            <h2>선택해주세요</h2>
            <div
              style={{
                fontSize: "15px",
                color: gray4,
                fontWeight: "bold",
              }}
            >
              {decodeCategory === "예복"
                ? "신랑님과 혼주분 함께 같은날 방문을 원하시는 경우, 각각 방문을 원하시는 날짜로 신청 넣어주세요."
                : "신랑신부님과 혼주분 함께 같은날 방문을 원하시는 경우, 각각 방문을 원하시는 날짜로 신청 넣어주세요."}
            </div>
            <>
              {clothesArray.map((data, index) => {
                return (
                  <div key={index}>
                    <SelectionItem
                      key={index}
                      title={data.name || ""}
                      isSelected={selectClothes.some(
                        (item) => item.no === data.no,
                      )}
                      onClick={() =>
                        setSelectClothes(
                          selectClothes.includes(data) ? [] : [data],
                        )
                      }
                    />
                    <div className={styles.underBar} />
                  </div>
                );
              })}
            </>
          </div>
          <nav className={styles.nav}>
            <div
              className={`${styles.flexCenter} ${styles.buttonStyle}`}
              style={{
                backgroundColor: selectClothes.length > 0 ? mainColor : gray6,
                color: selectClothes.length > 0 ? white : gray4,
              }}
              onClick={() => {
                {
                  if (selectClothes.length > 0) {
                    {
                      setRecoilSelect((prev) => ({
                        ...prev,
                        clothesCheckData: selectClothes,
                      }));
                      navigation(
                        `/company/detail/insertEntryInfoPage?no=${contructor_no}`,
                      );
                    }
                  }
                }
              }}
            >
              선택
            </div>
          </nav>
        </div>
      }
    </>
  );
}
